module.exports = __webpack_public_path__ + "img/modeBtn_unselect.7d094f33.svg";